export const POST_FUEL_DAILY_OPERATIONAL_DASHBOARD =
  'POST_FUEL_DAILY_OPERATIONAL_DASHBOARD';
export const CLEAR_FUEL_DAILY_OPERATIONAL_DASHBOARD =
  'CLEAR_FUEL_DAILY_OPERATIONAL_DASHBOARD';
export const FLAG_FUEL_DAILY_OPERATIONAL_DASHBOARD_ACTIVITY =
  'FLAG_FUEL_DAILY_OPERATIONAL_DASHBOARD_ACTIVITY';
